import { useTranslation } from "react-i18next";

export default function SpreadsheetPreview() {
  const { t } = useTranslation();

  const rows = [
    { product: "Sneakers", category: "categories.shoes", qc: true, seller: "preview.verified", status: "updated" },
    { product: "Hoodie", category: "categories.hoodies", qc: true, seller: "preview.sellerInfo", status: "updated" },
    { product: "Jacket", category: "categories.jackets", qc: true, seller: "preview.sellerInfo", status: "fresh" },
    { product: "Cap", category: "categories.headwear", qc: false, seller: "preview.sellerInfo", status: "updated" },
  ];

  return (
    <section id="spreadsheet" className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">{t("preview.title")}</h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3">{t("preview.subtitle")}</p>
        </div>

        <div className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-background-100 border-b border-background-200">
                  <th className="text-left px-4 md:px-5 py-3.5 font-heading font-semibold text-foreground-800 whitespace-nowrap">
                    {t("preview.colProduct")}
                  </th>
                  <th className="text-left px-4 md:px-5 py-3.5 font-heading font-semibold text-foreground-800 whitespace-nowrap">
                    {t("preview.colCategory")}
                  </th>
                  <th className="text-left px-4 md:px-5 py-3.5 font-heading font-semibold text-foreground-800 whitespace-nowrap">
                    {t("preview.colQc")}
                  </th>
                  <th className="text-left px-4 md:px-5 py-3.5 font-heading font-semibold text-foreground-800 whitespace-nowrap">
                    {t("preview.colSeller")}
                  </th>
                  <th className="text-left px-4 md:px-5 py-3.5 font-heading font-semibold text-foreground-800 whitespace-nowrap">
                    {t("preview.colStatus")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, idx) => (
                  <tr key={idx} className="border-b border-background-100 last:border-0 hover:bg-background-100/50 transition-colors">
                    <td className="px-4 md:px-5 py-3.5 font-medium text-foreground-900 whitespace-nowrap">
                      {row.product}
                    </td>
                    <td className="px-4 md:px-5 py-3.5 text-foreground-600 whitespace-nowrap">{t(row.category)}</td>
                    <td className="px-4 md:px-5 py-3.5 whitespace-nowrap">
                      {row.qc ? (
                        <span className="inline-flex items-center gap-1 text-primary-600 font-medium">
                          <i className="ri-checkbox-circle-fill"></i> QC
                        </span>
                      ) : (
                        <span className="inline-flex items-center gap-1 text-foreground-400">
                          <i className="ri-time-line"></i> —
                        </span>
                      )}
                    </td>
                    <td className="px-4 md:px-5 py-3.5 text-foreground-600 whitespace-nowrap">{t(row.seller)}</td>
                    <td className="px-4 md:px-5 py-3.5 whitespace-nowrap">
                      {row.status === "fresh" ? (
                        <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-accent-100 text-accent-900 text-xs font-medium">
                          <i className="ri-sparkling-line"></i>
                          {t("preview.fresh")}
                        </span>
                      ) : (
                        <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs font-medium">
                          <i className="ri-refresh-line"></i>
                          {t("preview.updated")}
                        </span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}